import { render, staticRenderFns } from "./Lista.vue?vue&type=template&id=0f480f86&scoped=true"
import script from "./Lista.vue?vue&type=script&lang=js"
export * from "./Lista.vue?vue&type=script&lang=js"
import style0 from "./Lista.vue?vue&type=style&index=0&id=0f480f86&prod&scoped=true&lang=css"
import style1 from "./Lista.vue?vue&type=style&index=1&id=0f480f86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f480f86",
  null
  
)

export default component.exports